import { useRef, useState } from "react"
import { QRCode } from "react-qr-code"
import { FiCopy, FiDownload, FiShare2, FiUserPlus, FiX } from "react-icons/fi"

type Props = {
  title: string
  url: string
  vcfUrl: string
  onClose: () => void
}

export function CardShareModal({ title, url, vcfUrl, onClose }: Props) {
  const [copied, setCopied] = useState(false)
  const qrRef = useRef<HTMLDivElement>(null)

  const copyUrl = async () => {
    await navigator.clipboard?.writeText(url)
    setCopied(true)
    window.setTimeout(() => setCopied(false), 1800)
  }

  const shareCard = async () => {
    if (navigator.share) {
      await navigator.share({ title, text: title, url })
      return
    }

    await copyUrl()
  }

  const downloadQr = () => {
    const svg = qrRef.current?.querySelector("svg")
    if (!svg) return

    const blob = new Blob([svg.outerHTML], { type: "image/svg+xml;charset=utf-8" })
    const downloadUrl = URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = downloadUrl
    link.download = `${title.replace(/[^a-zA-Z0-9א-ת]+/g, "-").replace(/^-|-$/g, "") || "cardly-qr"}.svg`
    link.click()
    URL.revokeObjectURL(downloadUrl)
  }

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-slate-950/60 p-4 backdrop-blur-sm sm:items-center" onClick={onClose}>
      <div className="w-full max-w-md rounded-[2rem] bg-white p-5 text-slate-900 shadow-2xl sm:p-6" onClick={(event) => event.stopPropagation()}>
        <div className="flex items-start justify-between gap-4">
          <div>
            <p className="text-sm font-medium text-brand-700">שיתוף הכרטיס</p>
            <h2 className="mt-1 text-xl font-semibold">{title}</h2>
            <p className="mt-1 text-sm text-slate-500">סרקו את הקוד או שלחו את הקישור.</p>
          </div>
          <button type="button" className="btn-secondary min-h-10 px-3" onClick={onClose} aria-label="סגירה"><FiX aria-hidden="true" /></button>
        </div>

        <div ref={qrRef} className="mx-auto mt-5 w-fit rounded-3xl bg-slate-50 p-4">
          <QRCode value={url} size={208} bgColor="#f8fafc" fgColor="#0f172a" />
        </div>

        <div className="mt-5 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-center text-sm text-slate-600" dir="ltr">{url}</div>
        <div className="mt-4 grid gap-2 sm:grid-cols-2">
          <button type="button" className="btn-primary gap-2 bg-brand-600" onClick={shareCard}><FiShare2 aria-hidden="true" />שיתוף</button>
          <button type="button" className="btn-secondary gap-2" onClick={copyUrl}><FiCopy aria-hidden="true" />{copied ? "הועתק" : "העתקת קישור"}</button>
          <button type="button" className="btn-secondary gap-2" onClick={downloadQr}><FiDownload aria-hidden="true" />הורדת QR</button>
          <a href={vcfUrl} download className="btn-secondary gap-2"><FiUserPlus aria-hidden="true" />שמירת איש קשר</a>
        </div>
      </div>
    </div>
  )
}
